import { CoffeeOutlined, CrownOutlined } from '@ant-design/icons';
import { Card, Avatar, Flex, Button, Tag, Space, Typography } from 'antd';
import { useTheme } from 'styled-components';
import {
  Company,
  License,
  LicenseEntitlement,
  LicenseType,
} from '../../../../types';
import { useState } from 'react';
import CreateLicenseModal from '../createLicenseModal';

export interface TrialLicenseCardProps {
  id: LicenseEntitlement;
  title: string;
  description: string;
  licenses: License[];
  isTrial: boolean;
  onRefresh: () => void;
}

const TrialLicenseCard = ({
  id,
  title,
  description,
  licenses,
  isTrial,
  onRefresh,
}: TrialLicenseCardProps) => {
  const [showConvertModal, setShowConvertModal] = useState(false);
  const theme = useTheme();
  const license = licenses[0];

  const company = {
    companyID: licenses[0]?.companyID,
    companyName: licenses[0]?.companyName,
  };

  return (
    <Card style={{ minWidth: 300 }}>
      <Card.Meta
        avatar={
          <Avatar
            icon={<CoffeeOutlined />}
            style={{
              backgroundColor: 'transparent',
              color: theme.antd.colorPrimary,
              fontSize: 20,
            }}
          />
        }
        title={
          <Flex>
            <Flex flex={1} justify="space-between" align="center">
              <span>{title} (Trial)</span>
              <Button type="primary" onClick={() => setShowConvertModal(true)}>
                <CrownOutlined /> Convert to Production
              </Button>
            </Flex>
          </Flex>
        }
        description={
          <Space direction="vertical">
            <Tag color={theme.antd.colorPrimary}>Active</Tag>
            <Typography.Text type="secondary">
              {license.startDate} to {license.endDate}
            </Typography.Text>
          </Space>
        }
      />
      <CreateLicenseModal
        open={showConvertModal}
        company={company as unknown as Company}
        entitlement={id}
        licenseKey={license.licenseKey}
        licenseType={LicenseType.PRODUCTION}
        action="convert"
        onClose={() => {
          setShowConvertModal(false);
        }}
        onConfirm={() => {
          setShowConvertModal(false);
          onRefresh();
        }}
      />
    </Card>
  );
};

export default TrialLicenseCard;
